// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-card {
  background-color: white;
  flex: 1 1;
  margin: 3%;
  border-radius: 5px;
  border: solid;
  border-color: rgb(81, 158, 202);
  border-width: 2px;
  align-items: center;
  display: flex;
  justify-content: center;
  max-height: 100px;
  width: 80%;
  /* padding: 2px; */
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.word-card.doing-nothing {
  animation: small-tilt-shake 1.0s 1.0s;
  animation-iteration-count: infinite;
}

.word-card.selected {
  background-color: rgba(184, 184, 202, 0.514);
}

.word-card.incorrect {
  background-color: rgba(255, 119, 119, 0.514);
  animation: tilt-shaking 0.3s 0.3s
}

.word-card.correct {
  background-color: rgb(119, 255, 153);
  animation-name: card-fade-out;
  animation-duration: 1000ms;
  animation-fill-mode: forwards;
}

.word-card.longword {
  font-size: 0.8em;
}

.word-card.very-longword {
  font-size: 0.7em;
}

@keyframes tilt-shaking {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(5deg);
  }

  50% {
    transform: rotate(0eg);
  }

  75% {
    transform: rotate(-5deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes small-tilt-shake {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(.75deg);
  }

  50% {
    transform: rotate(0eg);
  }

  75% {
    transform: rotate(-.75deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes card-fade-out {
  0% {
    opacity: 1;
    /* transform: rotateX(90deg); */
  }

  50% {
    opacity: 0.5;
    /* transform: rotateX(0deg); */
  }

  100% {
    display: none;
    opacity: 0;
    /* transform: rotateX(90deg); */
  }
}

@media(max-width: 600px) {
  .word-card.editor {
    font-size: small;
  }
}


@media(max-width: 450px) {
  .word-card.editor {
    font-size: x-small;
  }
}

@media(max-width: 400px) {
  .word-card.editor {
    font-size: xx-small;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/NewsiePreview/WordCard/WordCard.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,SAAO;EACP,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;AACA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C;AACF;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".word-card {\n  background-color: white;\n  flex: 1;\n  margin: 3%;\n  border-radius: 5px;\n  border: solid;\n  border-color: rgb(81, 158, 202);\n  border-width: 2px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  max-height: 100px;\n  width: 80%;\n  /* padding: 2px; */\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n.word-card.doing-nothing {\n  animation: small-tilt-shake 1.0s 1.0s;\n  animation-iteration-count: infinite;\n}\n\n.word-card.selected {\n  background-color: rgba(184, 184, 202, 0.514);\n}\n\n.word-card.incorrect {\n  background-color: rgba(255, 119, 119, 0.514);\n  animation: tilt-shaking 0.3s 0.3s\n}\n\n.word-card.correct {\n  background-color: rgb(119, 255, 153);\n  animation-name: card-fade-out;\n  animation-duration: 1000ms;\n  animation-fill-mode: forwards;\n}\n\n.word-card.longword {\n  font-size: 0.8em;\n}\n\n.word-card.very-longword {\n  font-size: 0.7em;\n}\n\n@keyframes tilt-shaking {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  25% {\n    transform: rotate(5deg);\n  }\n\n  50% {\n    transform: rotate(0eg);\n  }\n\n  75% {\n    transform: rotate(-5deg);\n  }\n\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes small-tilt-shake {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  25% {\n    transform: rotate(.75deg);\n  }\n\n  50% {\n    transform: rotate(0eg);\n  }\n\n  75% {\n    transform: rotate(-.75deg);\n  }\n\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes card-fade-out {\n  0% {\n    opacity: 1;\n    /* transform: rotateX(90deg); */\n  }\n\n  50% {\n    opacity: 0.5;\n    /* transform: rotateX(0deg); */\n  }\n\n  100% {\n    display: none;\n    opacity: 0;\n    /* transform: rotateX(90deg); */\n  }\n}\n\n@media(max-width: 600px) {\n  .word-card.editor {\n    font-size: small;\n  }\n}\n\n\n@media(max-width: 450px) {\n  .word-card.editor {\n    font-size: x-small;\n  }\n}\n\n@media(max-width: 400px) {\n  .word-card.editor {\n    font-size: xx-small;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
